export const TermsOfService = () => {
  return (
    <>
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '.lst-kix_list_2-6>li:before{content:"\\0025aa   "}.lst-kix_list_2-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_1-0{list-style-type:none}.lst-kix_list_2-4>li:before{content:"\\0025aa   "}.lst-kix_list_2-5>li:before{content:"\\0025aa   "}.lst-kix_list_2-8>li:before{content:"\\0025aa   "}.lst-kix_list_3-0>li:before{content:"\\0025cf   "}.lst-kix_list_3-1>li:before{content:"o  "}.lst-kix_list_3-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_3-7{list-style-type:none}ul.lst-kix_list_3-8{list-style-type:none}ul.lst-kix_list_1-3{list-style-type:none}ul.lst-kix_list_3-1{list-style-type:none}.lst-kix_list_3-5>li:before{content:"\\0025aa   "}ul.lst-kix_list_1-4{list-style-type:none}ul.lst-kix_list_3-2{list-style-type:none}ul.lst-kix_list_1-1{list-style-type:none}.lst-kix_list_3-4>li:before{content:"\\0025aa   "}ul.lst-kix_list_1-2{list-style-type:none}ul.lst-kix_list_3-0{list-style-type:none}ul.lst-kix_list_1-7{list-style-type:none}.lst-kix_list_3-3>li:before{content:"\\0025aa   "}ul.lst-kix_list_3-5{list-style-type:none}ul.lst-kix_list_1-8{list-style-type:none}ul.lst-kix_list_3-6{list-style-type:none}ul.lst-kix_list_1-5{list-style-type:none}ul.lst-kix_list_3-3{list-style-type:none}ul.lst-kix_list_1-6{list-style-type:none}ul.lst-kix_list_3-4{list-style-type:none}.lst-kix_list_3-8>li:before{content:"\\0025aa   "}.lst-kix_list_3-6>li:before{content:"\\0025aa   "}.lst-kix_list_3-7>li:before{content:"\\0025aa   "}ul.lst-kix_list_2-8{list-style-type:none}ul.lst-kix_list_2-2{list-style-type:none}.lst-kix_list_1-0>li:before{content:"\\0025cf   "}ul.lst-kix_list_2-3{list-style-type:none}ul.lst-kix_list_2-0{list-style-type:none}ul.lst-kix_list_2-1{list-style-type:none}ul.lst-kix_list_2-6{list-style-type:none}.lst-kix_list_1-1>li:before{content:"o  "}.lst-kix_list_1-2>li:before{content:"\\0025aa   "}ul.lst-kix_list_2-7{list-style-type:none}ul.lst-kix_list_2-4{list-style-type:none}ul.lst-kix_list_2-5{list-style-type:none}.lst-kix_list_1-3>li:before{content:"\\0025aa   "}.lst-kix_list_1-4>li:before{content:"\\0025aa   "}.lst-kix_list_1-7>li:before{content:"\\0025aa   "}.lst-kix_list_1-5>li:before{content:"\\0025aa   "}.lst-kix_list_1-6>li:before{content:"\\0025aa   "}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_list_2-0>li:before{content:"\\0025cf   "}.lst-kix_list_2-1>li:before{content:"o  "}.lst-kix_list_1-8>li:before{content:"\\0025aa   "}.lst-kix_list_2-2>li:before{content:"\\0025aa   "}.lst-kix_list_2-3>li:before{content:"\\0025aa   "}ol{margin:0;padding:0}table td,table th{padding:0}.c10{margin-left:36pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c7{margin-left:36pt;padding-top:14pt;padding-left:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c2{font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-style:normal}.c5{font-weight:700;text-decoration:none;vertical-align:baseline;font-size:18pt;font-style:normal}.c4{font-weight:700;text-decoration:none;vertical-align:baseline;font-size:13.5pt;font-style:normal}.c0{padding-top:14pt;padding-bottom:14pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c3{padding-top:0pt;padding-bottom:14pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c8{padding-top:14pt;padding-bottom:8pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c12{background-max-width:468pt;padding:72pt 72pt 72pt 72pt}.c1{padding:0;margin:0}.c6{font-weight:700;}.c11{margin-left:36pt;padding-left:0pt}.c9{font-size:13.5pt}.title{padding-top:0pt;font-size:28pt;padding-bottom:4pt;line-height:1.0;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;font-size:14pt;padding-bottom:8pt;line-height:1.1583333333333334;orphans:2;widows:2;text-align:left}li{font-size:12pt;}p{margin:0;font-size:12pt;}h1{padding-top:18pt;font-size:20pt;padding-bottom:4pt;line-height:1.1583333333333334;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:8pt;font-size:16pt;padding-bottom:4pt;line-height:1.1583333333333334;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:8pt;font-size:14pt;padding-bottom:4pt;line-height:1.1583333333333334;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:4pt;font-size:12pt;padding-bottom:2pt;line-height:1.1583333333333334;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}h5{padding-top:4pt;font-size:12pt;padding-bottom:2pt;line-height:1.1583333333333334;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:2pt;font-size:12pt;padding-bottom:0pt;line-height:1.1583333333333334;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}',
        }}
      />
      <p className="c3">
        <span className="c5">
          Databricks Antimatter Security Lakehouse Private Preview{' '}
        </span>
      </p>
      <p className="c0">
        <span className="c6 c9">Terms of Use</span>
      </p>
      <p className="c0">
        <span className="c6 c9">1. Acceptance &amp; Authority</span>
      </p>
      <p className="c0">
        <span className="c2">
          By clicking “I Accept” or by otherwise accessing or using the Private
          Preview, you agree to these Terms of Use (these “Terms”). If you are
          entering into these Terms on behalf of a legal entity, you represent
          that you have the authority to bind that entity.
        </span>
      </p>
      <p className="c0">
        <span className="c4">2. Services</span>
      </p>
      <p className="c0">
        <span className="c2">
          The “Services” refer to the Databricks Antimatter Security Lakehouse,
          an opt-in Private Preview offering provided by Antimatter Technologies
          Inc. (“Antimatter”) in partnership with Databricks through the
          Databricks platform. These Terms govern your use of the Private
          Preview features provided by Antimatter (“Private Preview”). Your use
          of Databricks services remains subject to your separate agreement(s)
          with Databricks, including the Databricks Master Cloud Services
          Agreement (“Databricks MCSA”).
        </span>
      </p>
      <p className="c0">
        <span className="c4">3. License Grant</span>
      </p>
      <p className="c0">
        <span className="c2">
          Subject to your compliance with these Terms, Antimatter grants you a
          non-exclusive, non-sublicensable, non-transferable, limited license to
          access and use the Private Preview for your internal business
          purposes. If you are an entity, you may permit a limited number of
          authorized users (as approved by Antimatter) to access the Private
          Preview on your behalf.
        </span>
      </p>
      <p className="c0">
        <span className="c4">4. Feedback</span>
      </p>
      <p className="c0">
        <span className="c2">
          You may provide feedback or suggestions regarding the Private Preview
          (“Feedback”). Antimatter may freely use and incorporate any Feedback
          to improve its products or services, with no obligation to you. To the
          extent any improvements or modifications arise from your Feedback, you
          hereby assign to Antimatter any rights you may have in those specific
          improvements or modifications. Antimatter will not publicly disclose
          your Feedback without your permission.
        </span>
      </p>
      <p className="c0">
        <span className="c4">5. Restrictions</span>
      </p>
      <p className="c0">
        <span className="c2">You shall not, nor permit others to:</span>
      </p>
      <ul className="c1 lst-kix_list_3-0 start">
        <li className="c7 li-bullet-0">
          <span className="c2">
            Reverse engineer, decompile, or disassemble any portion of the
            Private Preview;
          </span>
        </li>
        <li className="c10 li-bullet-0">
          <span className="c2">
            Modify or create derivative works of the Private Preview; or
          </span>
        </li>
        <li className="c3 c11 li-bullet-0">
          <span className="c2">
            Use the Private Preview in violation of these Terms or applicable
            law.
          </span>
        </li>
      </ul>
      <p className="c0">
        <span className="c4">6. Proprietary Rights</span>
      </p>
      <p className="c0">
        <span className="c2">
          All rights, title, and interest in and to the Private Preview (and any
          modifications or improvements not covered under Section&nbsp;4) belong
          to Antimatter (and its licensors, if applicable). Nothing in these
          Terms transfers any ownership to you.
        </span>
      </p>
      <p className="c0">
        <span className="c4">7. Your Data</span>
      </p>
      <p className="c0">
        <span className="c2">
          You retain ownership of any data you provide or process via the
          Private Preview (“Your Data”). You grant Antimatter a limited license
          to use Your Data as necessary to provide and improve the Private
          Preview. Antimatter will not otherwise use or disclose Your Data
          except as required by law or to provide the Private Preview.
        </span>
      </p>
      <p className="c0">
        <span className="c4">8. Suspension &amp; Termination</span>
      </p>
      <p className="c0">
        <span className="c2">
          These Terms remain in effect until terminated. Antimatter may suspend,
          discontinue, or terminate the Private Preview, in whole or part, at
          any time, with reasonable notice. You may also terminate at any time
          upon notice to Antimatter. Upon termination, you must cease using the
          Private Preview.
        </span>
      </p>
      <p className="c0">
        <span className="c4">9. Disclaimers &amp; Liability</span>
      </p>
      <p className="c0">
        <span className="c6">
          DISCLAIMER OF WARRANTIES. TO THE FULLEST EXTENT PERMITTED BY LAW, THE
          PRIVATE PREVIEW IS PROVIDED “AS IS,” AND ANTIMATTER DISCLAIMS ALL
          WARRANTIES, EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT.
        </span>
      </p>
      <p className="c0">
        <span className="c6">
          LIMITATION OF LIABILITY. TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO
          EVENT WILL ANTIMATTER BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
          CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR FOR ANY LOSS OF PROFITS OR
          REVENUES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          ANTIMATTER’S TOTAL LIABILITY FOR ALL CLAIMS ARISING OUT OF OR RELATED
          TO THESE TERMS OR THE PRIVATE PREVIEW WILL NOT EXCEED THE AMOUNT YOU
          PAID, IF ANY, FOR THE PRIVATE PREVIEW IN THE TWELVE (12) MONTHS PRIOR
          TO THE EVENT GIVING RISE TO LIABILITY. SOME STATES OR JURISDICTIONS DO
          NOT ALLOW THE EXCLUSION OR LIMITATION OF CERTAIN WARRANTIES OR
          LIABILITIES, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
        </span>
      </p>
      <p className="c0">
        <span className="c4">10. General</span>
      </p>
      <p className="c8">
        <span className="c2">
          These Terms form the entire agreement regarding the Private Preview
          and supersede all prior communications. They are governed by the laws
          of the State of California, without regard to conflict-of-law
          principles. Any dispute will be resolved in the state or federal
          courts located in Alameda, California. If any part of these Terms is
          held unenforceable, the remaining provisions remain in effect. Failure
          to enforce any provision is not a waiver of future enforcement.
        </span>
      </p>
    </>
  );
};
